import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { ThemeProvider } from "@mui/material/styles";

import configureStore from "./configureStore";
import MuiTheme from "./muiTheme";
import App from "./components/App";


let store = configureStore();

const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");
const rootElement = document.getElementById("root");

const root = createRoot(rootElement);
root.render(
  <BrowserRouter basename={baseUrl}>
    <Provider store={store}>
      <ThemeProvider theme={MuiTheme}>
        <App />
      </ThemeProvider>
    </Provider>
  </BrowserRouter>,
);
